<div [attr.data-landing-theme]="landingTheme" class="landing-theme-root w-full overflow-x-hidden">
  <!-- Hero Section -->
  <black-hero-section
    [customHero]="landingSettings?.hero"
    [isDefaultTenant]="isDefaultTenant"
    [tenantName]="currentTenant?.name"
    [theme]="landingTheme"
    [instructorAvatar]="instructorAvatar"
    [instructorName]="instructorName"
    [instructorTitle]="instructorTitle"
  ></black-hero-section>

  <!-- Live Classes & Batches Showcase -->
  @if (showLiveClasses) {
    <black-live-classes-section
      [settings]="landingSettings?.liveClasses"
      [theme]="landingTheme"
      [tenantName]="currentTenant?.name"
    ></black-live-classes-section>
  }

  <!-- Instructor Spotlight Section (Solo Tutors / Lead Teachers) -->
  @if (showInstructor) {
    <black-instructor-section
      [instructor]="landingSettings?.instructor"
      [tenantName]="currentTenant?.name"
      [theme]="landingTheme"
    ></black-instructor-section>
  }

  <!-- Free Class Demo / Video Preview Section -->
  @if (showVideoDemo) {
    <black-video-demo-section
      [videoDemo]="landingSettings?.videoDemo"
      [theme]="landingTheme"
    ></black-video-demo-section>
  }

  <!-- Custom Rich-Text / HTML Block (Quill-generated) -->
  @if (showCustomContent) {
    <section class="py-16 bg-base-100 border-b border-base-300">
      <div class="container mx-auto px-6 max-w-5xl">
        @if (customContentTitle) {
          <h2 class="text-3xl sm:text-4xl font-extrabold text-base-content tracking-tight mb-8 text-center">
            {{ customContentTitle }}
          </h2>
        }
        <div
          class="prose prose-slate dark:prose-invert max-w-none text-base-content/80 leading-relaxed"
          [innerHTML]="customContentHtml"
        ></div>
      </div>
    </section>
  }

  <!-- Features Section (Default Platform Marketplace Only) -->
  @if (showFeatures) {
    <black-features-section></black-features-section>
  }

  <!-- Courses & Batches Section (Default Platform Marketplace Only) -->
  @if (showCourses) {
    <black-courses-section></black-courses-section>
  }

  <!-- What You Get / Perks Section -->
  @if (showPerks) {
    <black-perks-section
      [perks]="landingSettings?.perks"
      [theme]="landingTheme"
    ></black-perks-section>
  }

  <!-- How It Works Section (Default Platform Marketplace Only) -->
  @if (isDefaultTenant) {
    <black-how-it-works-section></black-how-it-works-section>
    <black-vision-section></black-vision-section>
  }

  <!-- Student Results & Testimonials Section -->
  @if (showTestimonials) {
    <black-testimonials-section
      [testimonials]="landingSettings?.testimonials"
      [theme]="landingTheme"
    ></black-testimonials-section>
  }

  <!-- FAQ Section -->
  @if (showFaq) {
    <black-faq-section
      [customFaqs]="landingSettings?.faqItems"
      [isDefaultTenant]="isDefaultTenant"
      [supportEmail]="tenantSupportEmail"
      [theme]="landingTheme"
    ></black-faq-section>
  }

  <!-- Final CTA Section (Default Platform Marketplace Only) -->
  @if (showCta) {
    <black-final-cta-section></black-final-cta-section>
  }

  <!-- Floating WhatsApp Quick-Inquiry Widget -->
  @if (showWhatsApp) {
    <black-whatsapp-widget
      [whatsApp]="landingSettings?.whatsApp"
      [tenantName]="currentTenant?.name"
      [theme]="landingTheme"
    ></black-whatsapp-widget>
  }
</div>
